var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1331_4999)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#7B767C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9983 12.1405C16.981 11.9454 16.8422 11.7525 16.6625 11.6815C16.4578 11.6004 16.2512 11.5253 16.0436 11.4552V9.0436C16.0433 6.81365 14.2296 5 12.0002 5C9.77035 5 7.95669 6.81365 7.95669 9.0436V11.455C7.74908 11.5252 7.54257 11.6003 7.33778 11.6814C7.15773 11.7529 7.0192 11.9455 7.00186 12.1403H7V17.2873C7 17.496 7.14539 17.7111 7.33763 17.7875C8.82813 18.3779 10.3968 18.6776 12.0002 18.6776C13.6032 18.6776 15.172 18.3779 16.6622 17.7875C16.855 17.7108 17 17.4959 17 17.2873V12.1406L16.9983 12.1405ZM12.5509 14.5638V16.3848C12.5509 16.6888 12.3045 16.9351 12 16.9351C11.6958 16.9351 11.4494 16.6888 11.4494 16.3848V14.5638C11.1265 14.3726 10.8987 14.035 10.8987 13.6317C10.8987 13.0231 11.3918 12.5306 11.9998 12.5306C12.6082 12.5306 13.1012 13.0228 13.1012 13.6317C13.1014 14.035 12.8738 14.3726 12.5509 14.5638H12.5509ZM14.653 11.0717C13.7846 10.8853 12.8977 10.7912 11.9998 10.7912C11.1021 10.7912 10.2152 10.8853 9.34675 11.0717V9.04361C9.34675 7.58059 10.5367 6.39015 11.9996 6.39015C13.4628 6.39015 14.6529 7.5806 14.6529 9.04361L14.653 11.0717Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1331_4999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.bae654ce279c25e0a15e2f3edb9bf4f7.svg";
export { ForwardRef as ReactComponent };